module.exports = __webpack_public_path__ + "img/headerLogo3.bf0e3965.svg";